import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useDataProvider } from "ra-core";

import type { CrmDataProvider } from "../providers/types";
import {
  useConfigurationUpdater,
  type ConfigurationContextValue,
} from "./ConfigurationContext";

export const useConfigurationLoader = () => {
  const dataProvider = useDataProvider<CrmDataProvider>();
  const updateConfiguration = useConfigurationUpdater();
  const rawSaved =
    typeof window !== "undefined"
      ? localStorage.getItem("dotus_active_crm_id")
      : null;
  const activeCrmId =
    rawSaved && rawSaved !== "00000000-0000-0000-0000-000000000001"
      ? rawSaved
      : "fe386f56-b27f-446f-86ec-39a03b64add1";

  const { data } = useQuery<ConfigurationContextValue>({
    queryKey: ["configuration", activeCrmId],
    queryFn: () => dataProvider.getConfiguration(),
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: false,
  });

  useEffect(() => {
    if (data && Object.keys(data).length > 0) {
      updateConfiguration(data);
    }
  }, [data, updateConfiguration]);
};
